// extracted by mini-css-extract-plugin
module.exports = {"teaserCard":"teaser-carousel-block-module--teaserCard--3O2up"};